import { render, staticRenderFns } from "./step_1.vue?vue&type=template&id=3aab00ec&scoped=true&"
import script from "./step_1.vue?vue&type=script&lang=js&"
export * from "./step_1.vue?vue&type=script&lang=js&"
import style0 from "./step_1.vue?vue&type=style&index=0&id=3aab00ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aab00ec",
  null
  
)

export default component.exports